module.exports = __webpack_public_path__ + "img/Zhijian_James_Chen.4ac54ec4.png";